export default __webpack_public_path__ + "static/media/icon_thumbs_up.d655871a.png";